import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@mui/material";

import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";

export const RfidFilter: React.FC<ColumnFilterProps> = ({
  tableName,
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const value = useSelector((state: RootState) => filterSelectorValue(state, fieldName));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div>
      <Checkbox
        checked={!!value}
        onChange={() => {
          dispatch(
            filterUpdateAction({ id: fieldName, name: fieldName, operator: FilterOperator.IsEmpty, value: !value })
          );
        }}
      />
      {t(`${tableName}.filters.noRfid`)}
    </div>
  );
};
